/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import RouteAllotmentService from "src/service/routeAllotmentToVehicle";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Select from "react-select";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Route Allotment To vehicle ",
  },
];

const validationSchema = yup.object({
  vehicle_no: yup
    .string("Select vehicle No")
    .required("vehicle No is required"),
});

const RouteAllotmentToVehicle = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [vehicleList, setvehicleList] = useState([]);
  const [routeList, setrouteList] = useState([]);

  const [selectedVehichle, setSelectedVehichle] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [vehicleNoList, setvehicleNoList] = useState(null);
  const [routeName, setRouteName] = useState(null);

  const [payload, setPayload] = useState([]);

  const fetchVehicleNoData = async () => {
    try {
      const res = await RouteAllotmentService.getVehicleNoList({});
      setvehicleList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRouteData = async (id) => {
    try {
      const res = await RouteAllotmentService.getRouteList({});
      setrouteList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const initialValues = {
    vehicle_no: "",
    c_by: sessionData.data.id,

    routes: [],
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const payloadval = {
          vehicle_no: values.vehicle_no,
          routes: [
            {
              route_id: values.route_id,
              off_route_margin: values.off_route_margin,
            },
          ],
          c_by: sessionData.data.id,
        };
        if (payload.length === 0) {
          setPayload(payloadval);
        } else {
          setPayload((preval) => ({
            ...preval,
            routes: [...preval.routes, ...payloadval.routes],
          }));
        }
        try {
          setSelectedRoute(null);
          values.off_route_margin = "";
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  const postData = async () => {
    try {
      const res = await RouteAllotmentService.saveAllotmentData(payload);
      swal("success", res.message, "success");
      setSelectedVehichle(null);
      setSelectedRoute(null);
      setPayload([]);
      setTimeout(() => {
        navigate("/routeallot2vehicle");
      }, 1000);
    } catch (error) {
      swal("error", error, "error");
    }
  };

  useEffect(() => {
    fetchVehicleNoData();
    fetchRouteData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const deleteRow = (data) => {
    swal("success", "Deleted Successfully", "success");
    setPayload((preval) => ({
      ...preval,
      routes: [...preval.routes.filter((item, ind) => ind !== data)],
    }));
  };

  const handleVehichleNo = (event) => {
    setvehicleNoList(event.target.value);
  };
  const handleRouteName = (event) => {
    setRouteName(event.target.value);
  };

  return (
    <>
      <Breadcrumb title="Route Allotment" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Route Allotment To Vehicle
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>
                Vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Select
                id="vehicle_no"
                name="vehicle_no"
                value={selectedVehichle}
                onChange={(selectedVehichle) => {
                  // Update the selected option in the state
                  setSelectedVehichle(selectedVehichle);

                  // Call both functions
                  const value = selectedVehichle ? selectedVehichle.value : "";
                  handleVehichleNo({
                    target: {
                      name: "vehicle_no",
                      value: value,
                    },
                  });
                  handleChange({
                    target: {
                      name: "vehicle_no",
                      value: value,
                    },
                  });
                }}
                onBlur={handleBlur}
                options={vehicleList.map((option) => ({
                  label: `${option.vehicle_no}`,
                  value: option.vehicle_no,
                }))}
                placeholder="Select Vehichle"
                isSearchable
                isClearable
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>
                Route Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Select
                id="route_id"
                name="route_id"
                value={selectedRoute}
                onChange={(selectedRoute) => {
                  // Update the selected option in the state
                  setSelectedRoute(selectedRoute);

                  // Call both functions
                  const value = selectedRoute ? selectedRoute.value : "";
                  handleRouteName({
                    target: {
                      name: "route_id",
                      value: value,
                    },
                  });
                  handleChange({
                    target: {
                      name: "route_id",
                      value: value,
                    },
                  });
                }}
                onBlur={handleBlur}
                options={routeList.map((option) => ({
                  label: `${option.route_name} - ${option.distance} Km`,
                  value: option.id,
                }))}
                placeholder="Select Route"
                isSearchable
                isClearable
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>
                Off Route Margin (in metre){" "}
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="off_route_margin"
                name="off_route_margin"
                value={values.off_route_margin}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter Off Route Margin"
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ marginTop: "15px" }}
            >
              <Button
                color="info"
                variant="contained"
                type="submit"
                style={{ float: "right" }}
              >
                Add
              </Button>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#895c5c33" }}>
                    <TableRow>
                      <TableCell style={{ textAlign: "center" }}>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          Route Name
                        </Typography>
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          Off Route Margin (In metre)
                        </Typography>
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Typography style={{ fontSize: "14px" }} variant="h6">
                          Action
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {payload?.routes?.map((data, index) => (
                    <TableBody>
                      <TableRow key={data.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {
                              routeList.find((val) => val.id === data.route_id)
                                ?.route_name
                            }
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {data?.off_route_margin}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <DeleteOutlinedIcon
                            style={{
                              color: "red",
                              fontSize: "18px",
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => deleteRow(index)}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ))}
                </Table>
              </TableContainer>
            </Grid>

            <Grid item lg={12} md={12} sm={12}>
              <Button onClick={postData} color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default RouteAllotmentToVehicle;
